var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 55.6813L33.2366 10.2372C33.7473 9.27944 35.1283 9.29694 35.6135 10.269L44.0011 27.0441L9 55.6813Z",
    fill: "#FF8F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 55.6695L17.8235 1.26033C18.0541 -0.163577 19.9665 -0.472223 20.6347 0.806907L37.6372 33.3961L9 55.6695Z",
    fill: "#FFA000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01172 55.6592L9.32991 55.4094L37.2178 32.5935L29.3521 17.5176L9.01172 55.6592Z",
    fill: "#FF6F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 55.6813L51.4245 14.773C52.3138 13.9155 53.7982 14.4214 53.9796 15.6433L59.9106 55.6813L36.0463 69.591C35.0774 70.1351 33.8953 70.1351 32.9264 69.591L9 55.6813Z",
    fill: "#FFC400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.9ede6674971a1b5fde8d37d9f2c0517e.svg";
export { ForwardRef as ReactComponent };